module.exports = __webpack_public_path__ + "img/Face.8426b051.png";